<script lang="ts" setup>
	defineProps<{
		title?: string
		description?: string
	}>()
</script>

<template>
	<div class="relative sm:space-y-5 space-y-2 text-center flexed justify-center flex-col">
		<div class="sm:space-y-5 flexed justify-center flex-col space-y-1.5">
			<div class="sm:h-[100px] h-[60px] sm:w-[100px] w-[60px] bg-white rounded-full border flexed justify-center">
				<slot name="icon" />
			</div>

			<h6 class="text-gray-700 font-medium text-xl">
				<slot name="title">
					<span v-html="title"></span>
				</slot>
			</h6>
		</div>

		<p class="text-gray-600 text-base max-w-[371px] text-balance">
			<slot name="description">
				<span v-html="description"></span>
			</slot>
		</p>
	</div>
</template>
